export default __webpack_public_path__ + "static/media/cp_geo_cf.c2b4d408.svg";